<template>
  <div class="row">
    <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
      <div class="card bcard mb-4">
        <div class="card-body px-4 px-lg-5">
          <div class="text-center">
            <h2 class="text-dark-m2">
              イベント情報送信
            </h2>
            <br>
            <h6 class="text-secondary-d2">
              ステップ１：写真を撮影または写真アップロード
            </h6>
          </div>


          <div class="mt-4">
            <div class="row text-600 text-95 text-secondary-d3 brc-green-l1 py-25 border-y-2 justify-content-center">
              <input type="file" ref="control" class="d-none" accept="image/*" @change="fileChange">
              <button @click="upload" type="button" class="btn btn-app btn-primary my-1" id="btn-app-1">
                <i class="d-block h-6 fa fa-camera text-190"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  methods: {
    upload(){
      this.$refs.control.click();
    },
    fileChange(e){

      const files = this.$refs.control.files;

      const page = this;

      if(files.length > 0){
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);

        console.log(files[0])
        reader.onload = function(e) {
          page.$store.commit("changeImage",{
            file: files[0],
            url: this.result
          })
          // var src = this.result;
          // var str = '<img src="'+src+'">';
          // var target=this.upMode=='head'?'.el-upload--picture-card':'.el-upload-dragger';
          // var nim = document.querySelector(target);
          // if(nim) {
          //   nim.innerHTML='';
          //   nim.insertAdjacentHTML("beforeEnd", str)
          // }
        };

        this.$router.push({ name: 'Edit' })
      }
    }
  }
};
</script>
